import React from "react";
import "antd/dist/antd.css";
import Icon from "@ant-design/icons";

function CandidateAvatarIcon() {
  const UserSvg = () => (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="24"
        viewBox="0 0 18 24"
      >
        {" "}
        <g id="fi-rr-user" transform="translate(-3)">
          {" "}
          <path
            id="Path_2793"
            data-name="Path 2793"
            d="M12,12A6,6,0,1,0,6,6a6,6,0,0,0,6,6ZM12,2A4,4,0,1,1,8,6a4,4,0,0,1,4-4Z"
            fill="#babec4"
          />{" "}
          <path
            id="Path_2794"
            data-name="Path 2794"
            d="M12,14a9.01,9.01,0,0,0-9,9,1,1,0,1,0,2,0,7,7,0,1,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,12,14Z"
            fill="#babec4"
          />{" "}
        </g>{" "}
      </svg>
    </>
  );

  const UserIconSvg = (props) => <Icon component={UserSvg} {...props} />;

  return (
    <>
      <UserIconSvg style={{ color: "white" }} />
    </>
  );
}

export default CandidateAvatarIcon;
